var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighGood = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.814,
    viewBox: "0 0 14 10.814",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.65 -267.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-348.3,275.129v.006l-.072.5-1.832-.246.072-.517a5.343,5.343,0,0,0,.048-.691A5.258,5.258,0,0,0-352.179,270l-.421-.306,1.111-1.478.415.306A7.108,7.108,0,0,1-348.3,275.129Z",
    transform: "translate(-6.407 -0.11)",
    fill: "#00ac3e"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-357.5,277.939h-9.192a5.676,5.676,0,0,1-1.142-3.434,5.745,5.745,0,0,1,5.749-5.739,5.749,5.749,0,0,1,2.06.384l.3-.765a6.562,6.562,0,0,0-8.484,3.762,6.564,6.564,0,0,0-.44,2.358,6.491,6.491,0,0,0,1.442,4.1l.12.153h9.985l.12-.153a6.491,6.491,0,0,0,.9-1.476l-.752-.329A5.636,5.636,0,0,1-357.5,277.939Z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-354.27,274.935l-3.374,1.895a1.219,1.219,0,0,0-.756-.267,1.239,1.239,0,0,0-1.248,1.23,1.239,1.239,0,0,0,1.23,1.248h0a1.239,1.239,0,0,0,1.248-1.23h0a1.253,1.253,0,0,0-.032-.288l3.333-1.869ZM-358.4,278.2a.41.41,0,0,1-.41-.41h0a.409.409,0,0,1,.41-.41h0a.409.409,0,0,1,.41.41h0a.409.409,0,0,1-.409.41Z",
    transform: "translate(-3.594 -2.791)",
    fill: "#afafaf"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighGood);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/high-good.59f1ccdfb0b428b5063cd9660268ae74.svg";